// extracted by mini-css-extract-plugin
export default {"filterAssignerContainer":"PredefinedSearchEditBasic_filterAssignerContainer__sbH2V","nameInput":"PredefinedSearchEditBasic_nameInput__M39h3"};